<dw-ui-panel [defaultOpenedPanel]="info" [triggers]="triggers()">
  <dw-grid-detail-navigation
    header-actions
    [context]="[GoliathDocumentEntityNames.StockDocTransfer.shortName]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-2 mt-2 header">
                    <document-stock-doc-location-card
                      [form]="form"
                      [warehouses]="warehouses"
                      [entityLinesNotEmpty]="entityLinesNotEmpty()"
                      class="card card-double"
                      [companySiteLabel]="'::OriginalSite'"
                      [warehouseLabel]="'Doc::StockDoc:OriginalWarehouse'"
                    >
                      <div class="d-flex flex-column gap-2 transfer-col">
                        <div class="row row-cols-md-12">
                          <div class="col-12 p-0">
                            <label for="siteToId" class="form-label text-primary" dwInputRequired>
                              {{ 'Doc::StockDoc:SiteToId' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="siteToId"
                              bindLabel="code"
                              bindValue="id"
                              formControlName="siteToId"
                              [loading]="companySiteStore.loading()"
                              [items]="companySiteStore.entities()"
                              [readonly]="entityLinesNotEmpty()"
                            >
                            </ng-select>
                          </div>
                        </div>

                        <div class="row row-cols-md-12">
                          <div class="col-12 p-0">
                            <label for="warehouseToId" class="form-label text-primary">
                              {{ 'Doc::StockDoc:WarehouseTo' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="warehouseToId"
                              bindLabel="code"
                              bindValue="id"
                              formControlName="warehouseToId"
                              [items]="warehousesToTransfer"
                              [readonly]="entityLinesNotEmpty()"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                @if (item != null) {
                                  {{ item.code }} - {{ item.name }}
                                }
                              </ng-template>
                              <ng-template
                                ng-option-tmp
                                let-item="item"
                                let-index="index"
                                let-search="searchTerm"
                              >
                                <span [title]="item.code + ' - ' + item.name"
                                  >{{ item.code }} - {{ item.name }}
                                </span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                    </document-stock-doc-location-card>

                    <document-stock-doc-core-card
                      [form]="form"
                      [dayBooks$]="dayBooks$"
                      [entity]="entity"
                      class="card"
                    ></document-stock-doc-core-card>

                    <document-stock-doc-quantitative-data-card
                      [form]="form"
                      class="card"
                    ></document-stock-doc-quantitative-data-card>

                    <document-stock-doc-followup-card
                      [form]="form"
                      class="card"
                    ></document-stock-doc-followup-card>
                  </div>

                  @if (isSerialEntry) {
                    <div class="card-group mb-2 mt-2 header">
                      <div class="card p-2 border">
                        <div class="col col-md-6 p-0 d-flex align-items-end">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="copyLineData"
                              formControlName="copyLineData"
                            />
                            <label for="copyLineData" class="form-check-label text-primary">
                              {{ 'Doc::StockDoc:CopyLineData' | abpLocalization }}
                            </label>
                          </div>
                        </div>
                        <div class="col col-md-6 p-0 d-flex align-items-end">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="printLabel"
                              formControlName="printLabel"
                            />
                            <label for="printLabel" class="form-check-label text-primary">
                              {{ 'Doc::StockDoc:PrintLabel' | abpLocalization }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-stock-doc-transfer-lines-grid
                        #stockDocLineGrid
                        [stockDoc]="entity"
                        [copyLineData]="this.form?.get('copyLineData')?.value"
                        [printLabel]="this.form?.get('printLabel')?.value"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                      ></document-stock-doc-transfer-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-classifications
                class="d-block"
                [form]="form"
                [docClassificationValues]="docClassificationValues$ | async"
              ></document-doc-classifications>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-customer-others
                class="d-block"
                [docForm]="form"
                [docRoleInput]="docRole"
              ></document-doc-customer-others>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <core-annexes-list
                class="d-block"
                [canDownload]="true"
                [canUpload]="true"
                [canDelete]="true"
                [canPreview]="true"
                [canEdit]="true"
                [folderName]="'quote-detail/' + entity?.id"
                [annexes]="annexesAsPromise$ | async"
                (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
                (deleteAnnex)="deleteAnnex($event)"
                (deleteAnnexes)="deleteAnnexes($event)"
              ></core-annexes-list>
            </div>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      <button
        (click)="saveActionBtns()[0].action()"
        class="btn btn-primary"
        type="submit"
        form="generalForm"
        [disabled]="entity?.isStockValidated"
      >
        {{ buttonLabel() | abpLocalization }}
      </button>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <!-- <div class="aside-header">

      </div> -->
        @if (entity?.isStockValidated) {
          <div class="aside-tags">
            <div>
              <span class="ui-tag badge rounded-pill bg-success">
                {{ '::Validated' | abpLocalization }}
              </span>
            </div>
          </div>
        }
        @if (entity != null) {
          <div class="aside-body">
            <div class="audit-container mb-3">
              <core-informations-audited-entity [auditedEntity]="entity">
              </core-informations-audited-entity>
            </div>
          </div>
        }
        <!-- <document-side-panel-tags [entity]="entity"> </document-side-panel-tags> -->
        <label for="note" class="form-label text-primary mt-3">{{
          'GoliathCore::Note' | abpLocalization
        }}</label>
        <textarea
          *ngIf="entity != null"
          name="note"
          class="form-control"
          rows="5"
          [(ngModel)]="entity.note"
          (input)="updateNote($event)"
        ></textarea>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.StockDocTransfer.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>

<ng-template #report let-offcanvas>
  <dw-ui-dialog-box [title]="'Reporting::Report:ReportPdf'" [displayFooter]="false">
    <dw-report-viewer
      [reportName]="docRole"
      [dataId]="entity.id"
      [templateId]="printTemplateId"
      (pdfRequested)="downloadPdfReport()"
    ></dw-report-viewer>
  </dw-ui-dialog-box>
</ng-template>
